import { Autocomplete, InputBase, Typography } from '@mui/material';


export interface AutoCompleteInputOption {
  label: string,
  value: number | string
}
export interface AutocompleteFreeSoloProps {
  optionsList: AutoCompleteInputOption[] | { label: string }[];
  value?: AutoCompleteInputOption | null;
  placeholder: string;
  onChange?: any;
}

export default function AutocompleteFreeSolo(props: AutocompleteFreeSoloProps) {
  const { placeholder, optionsList = [], onChange } = props;
  const innerStyle = {
    fontSize: '0.8rem',
    lineHeight: 1.43,
    letterSpacing: '1px',
    fontWeight: '300',
  };

  return (
    <Autocomplete
      onChange={(event, newValue) => onChange(event, newValue)}
      freeSolo
      disablePortal={true}
      id='combo-box-demo'
      options={optionsList}
      sx={{ ml: 1, flex: 1 }}
      renderOption={(props, option) => <li {...props}>
        <Typography
          sx={innerStyle}
          noWrap
          component='div'
          variant='body2'
          color='text.primary'
          fontWeight='light'
        >
          {option.label}
        </Typography>
      </li>}
      renderInput={(params) => {
        const { ...rest } = params;
        return (
          <InputBase placeholder={placeholder} {...params.InputProps}
            {...rest} />
        );
      }}
    />
  );
}
